import type { AppLocale } from '@/shared/lib';

/** Public origin, without a trailing slash; set per environment. */
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'https://krasahub.beauty').replace(
  /\/$/,
  '',
);

export const BRAND = 'KrasaHub';

/** Open Graph locale codes. */
export const OG_LOCALE: Record<AppLocale, string> = { uk: 'uk_UA', ru: 'ru_UA', en: 'en_US' };

export const absoluteUrl = (path: string): string => `${SITE_URL}${path}`;
